export var ZeroEtlTargetTablesSortField;
(function (ZeroEtlTargetTablesSortField) {
    ZeroEtlTargetTablesSortField["ZERO_ETL_TARGET_TABLES_SORT_FIELD_UPDATED_TIME"] = "UPDATED_TIME";
    ZeroEtlTargetTablesSortField["ZERO_ETL_TARGET_TABLES_SORT_FIELD_ICEBERG_TABLE"] = "ICEBERG_TABLE";
    ZeroEtlTargetTablesSortField["ZERO_ETL_TARGET_TABLES_SORT_FIELD_STATUS"] = "STATUS";
    ZeroEtlTargetTablesSortField["ZERO_ETL_TARGET_TABLES_SORT_FIELD_COMPLETE_THROUGH_PIT"] = "COMPLETE_THROUGH_PIT";
})(ZeroEtlTargetTablesSortField || (ZeroEtlTargetTablesSortField = {}));
